import { NavigationGuardNext, Route } from 'vue-router';
import Store from '@/Store';

export default function UserIsLoggedIn(to: Route, from: Route, next: NavigationGuardNext): void {
  if (!Store.state.user.jwt) {
    next({ name: 'auth_login' })
  } else {
    next()
  }
}
